<script setup>
/**
 * One freight handling unit's fields: what it is (pallet, crate, ...), its
 * freight class and whether it stacks. Edits the package (or group package)
 * object it is given in place, like form-weight-dims.
 */
import {computed} from "vue";
import store from "@/store";
import {densityClass} from "@/lib/freight";

const props = defineProps({
  value: {type: Object, required: true},
  state: {type: Object, default: () => ({})},
})

const freight = computed(() => store.state.settings.defaults.freight || {handling_types: [], classes: []})
// the package object itself, edited in place (as form-weight-dims does)
const unit = computed(() => props.value)
// left on Auto, the class its density gives - worked out the same way when it is quoted
const auto = computed(() => densityClass(unit.value.pkg_length, unit.value.pkg_width, unit.value.pkg_height, unit.value.pkg_weight))
</script>

<template>
  <modal-row label="Freight Unit" :feedback="[state.handling_type, state.freight_class]">
    <div class="d-flex align-items-center flex-wrap">
      <b-form-select size="sm" class="w-auto mr-2 mb-1" v-model="unit.handling_type"
                     :state="state.handling_type | state" :options="freight.handling_types"/>
      <!-- a fixed width: the Auto class changes as the weight is typed -->
      <b-form-select size="sm" class="mr-2 mb-1" style="width: 10.5em" v-model="unit.freight_class" :state="state.freight_class | state">
        <b-form-select-option :value="null">Class: Auto{{ auto ? ' (' + auto + ')' : '' }}</b-form-select-option>
        <b-form-select-option v-for="c in freight.classes" :key="c" :value="c">Class {{ c }}</b-form-select-option>
      </b-form-select>
      <b-form-checkbox switch class="mb-1" v-model="unit.stackable">Stackable</b-form-checkbox>
    </div>
  </modal-row>
</template>
